import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '../../models/api-response.model';
import { EnrolledCourseDetail, CreateEnrollmentRequest } from '../models/enrollment.model';

@Injectable({
  providedIn: 'root',
})
export class EnrollmentService {
  private readonly http = inject(HttpClient);

  getEnrolledCourseIds(idStudent: number): Observable<ApiResponse<number[]>> {
    return this.http.get<ApiResponse<number[]>>(`/api/v1/enrollments/student/${idStudent}/enrolled-courses`);
  }

  getActiveEnrolledCourses(idStudent: number): Observable<ApiResponse<EnrolledCourseDetail[]>> {
    return this.http.get<ApiResponse<EnrolledCourseDetail[]>>(`/api/v1/enrollments/student/${idStudent}/active-courses`);
  }

  getCompletedCourses(idStudent: number): Observable<ApiResponse<EnrolledCourseDetail[]>> {
    return this.http.get<ApiResponse<EnrolledCourseDetail[]>>(`/api/v1/enrollments/student/${idStudent}/completed-courses`);
  }

  createEnrollment(request: CreateEnrollmentRequest): Observable<ApiResponse<any>> {
    return this.http.post<ApiResponse<any>>('/api/v1/enrollments', request);
  }
}